import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class seitenNavigation extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
    }
    connectedCallback() {
        const liste = this.querySelector('.container');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }
    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get("seiten-navigation")) {
    customElements.define("seiten-navigation", seitenNavigation);
}
